import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";

export default function FramedPreview({ card, open, onOpenChange }) {
  if (!card) return null;
  const base = card.image.split("/").pop().replace(/\.[^.]+$/, "");
  const framedSrc = `/images/cards/frame-${base}.jpg`;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="framed-preview-modal" aria-describedby={undefined}
        className="max-w-3xl border-none bg-transparent p-0 shadow-none sm:rounded-none [&>button]:text-linen [&>button]:opacity-90">
        <DialogTitle className="sr-only">{card.title} — shown in an example frame</DialogTitle>
        {/* wall */}
        <div className="px-5 py-8 sm:px-14 sm:py-12"
          style={{ background: "linear-gradient(165deg, #8B9187 0%, #7B8176 55%, #6A7065 100%)" }}>
          {/* wood frame — texture sampled from Richard's own framed card */}
          <div className="p-2 sm:p-2.5 shadow-[0_24px_50px_-12px_rgba(0,0,0,0.55)]"
            style={{ backgroundImage: "url(/images/frame-wood.jpg)", backgroundSize: "cover", backgroundPosition: "center" }}>
            {/* generous warm mat, matched to the card template */}
            <div className="bg-[#E8E0D0] px-[13%] py-[11%] shadow-[inset_0_2px_6px_rgba(0,0,0,0.28)]">
              <img src={framedSrc} alt={`${card.title} — shown in an example frame and mat`}
                data-testid="framed-preview-image"
                className="w-full h-auto block shadow-[0_1px_3px_rgba(0,0,0,0.25)]" />
            </div>
          </div>
          <div className="text-center mt-6">
            <p className="font-serif text-xl text-linen" data-testid="framed-preview-title">{card.title}</p>
            <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-linen/70 mt-2 max-w-[46ch] mx-auto leading-relaxed">
              Shown framed for inspiration — your card arrives ready for a frame that suits your taste
            </p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
